import React from 'react'
import styled from 'styled-components'
import { useStoreState } from 'easy-peasy'
import Paragraph from './Paragraph'
import media from '../../utils/media'
import Image from './Image'
import { useTranslations } from '../../utils/Text'
/* eslint-disable import/no-cycle */
import components from './index'

const Wrapper = styled.div`
  .section-title {
    margin-bottom: 60px;
    ${media.tabletS`
      padding: 0 15px;
      margin-bottom: 30px;
    `}
  }
  .card-wrapper {
    span {
      width: 100%;
    }
    .text-util {
      text-align: center;
      ${media.tabletS`
        padding: 0 30px 20px;
    `}
    }
  }
  .paragraph-check {
    padding: 10px 0 0;
  }
`
const ContentWrapper = styled.div`
  padding: 30px 18px 0;
  max-width: 726px;
  margin: 0 auto;
`

const Circle = styled.div`
  border-radius: 50%;
  width: 25px;
  min-width: 26px;
  height: 25px;
  padding: 3px 8px 3px 7px;
  margin: 10px 10px 0 6px;
  background: #414141;
  color: #fff;
  text-align: center;
  font-weight: 500;
  font-variant-numeric: lining-nums;
`

export default function StepsSection({ config }) {
  const {
    listContent1,
    listContent2,
    listContent3,
    textAlign,
    titleFontSize,
    titleLineHeight,
    subtitleFontSize,
    subtitleLineHeight,
    marginBText,
    imageSrc,
    imageSectionSrc,
    alt,
    fontFamily,
    sectionTitle,
    video,
  } = config

  const imgToShowVideo = useTranslations(imageSectionSrc, {})
  const locale = useStoreState(state => state.locale.locale)

  const LOCALE = {
    es: locale === 'es-es',
  }

  return (
    <Wrapper>
      {/* video */}
      {LOCALE.es && (
        <>
          {imageSrc && <Image src={imgToShowVideo} alt={alt} />}
          <ContentWrapper>
            {sectionTitle && (
              <Paragraph
                paragraph={sectionTitle}
                marginB={marginBText}
                fontSize={titleFontSize}
                lineHeight={titleLineHeight}
              />
            )}
            {listContent1 && (
              <div className="row">
                <div className="col-11 col-md-10 mx-auto">
                  <div className="d-flex">
                    <Circle> 1 </Circle>
                    <Paragraph
                      classN="paragraph-check"
                      paragraph={listContent1}
                      textAlign={textAlign}
                      marginB={marginBText}
                      fontSize={subtitleFontSize}
                      lineHeight={subtitleLineHeight}
                      fontFamily={fontFamily}
                    />
                  </div>
                  <div className="d-flex">
                    <Circle> 2 </Circle>
                    <Paragraph
                      classN="paragraph-check"
                      paragraph={listContent2}
                      textAlign={textAlign}
                      marginB={marginBText}
                      fontSize={subtitleFontSize}
                      lineHeight={subtitleLineHeight}
                      fontFamily={fontFamily}
                    />
                  </div>
                  <div className="d-flex">
                    <Circle> 3 </Circle>
                    <Paragraph
                      classN="paragraph-check"
                      paragraph={listContent3}
                      textAlign={textAlign}
                      marginB={marginBText}
                      fontSize={subtitleFontSize}
                      lineHeight={subtitleLineHeight}
                      fontFamily={fontFamily}
                    />
                  </div>
                </div>
              </div>
            )}

            {video &&
              video.map(item => {
                const TypeComponent = components[item.type]
                return (
                  <TypeComponent
                    key={`video-${item.type}`}
                    config={item.config}
                  />
                )
              })}
          </ContentWrapper>
        </>
      )}
    </Wrapper>
  )
}
